<template>
  <div :class="`volume ${isPortrait ? 'portrait' : ''}`">
    <btn icon medium @click="requestMute">
      <audio-icon :isMuted="muted" :volume="volume" />
    </btn>
    <input min="0" max="1" step="0.01" :value="muted ? 0 : volume" type="range" @change="setVolume" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import KeyProcessor from '@/js/KeyProcessor'

export default {
  name: 'volume',
  props: {
    isPortrait: Boolean
  },
  computed: {
    ...mapState({
      muted: state => state.video.audio.muted,
      volume: state => parseFloat(state.video.audio.volume)
    })
  },
  methods: {
    ...mapActions({ toggleMute: 'video/toggleMute', changeVolume: 'video/changeVolume' }),
    requestMute() {
      document.activeElement.blur()
      this.toggleMute()
    },
    setVolume(event) {
      document.activeElement.blur()
      this.changeVolume(event.target.value)
    },
    raiseVolume() {
      this.changeVolume(Math.min(this.volume + 0.05, 1))
    },
    lowerVolume() {
      this.changeVolume(Math.max(this.volume - 0.05, 0))
    }
  },
  mounted() {
    this.keyProcessor = new KeyProcessor({
      77: this.toggleMute,
      38: this.raiseVolume,
      40: this.lowerVolume
    })
  },
  destroyed() {
    this.keyProcessor.removeListener()
  }
}
</script>

<style lang="scss" scoped>
.volume {
  display: flex;
  align-items: center;

  &:not(.portrait) button {
    margin-right: 6px;
  }

  &.portrait input {
    display: none;
  }

  input {
    -webkit-appearance: none;
    appearance: none;
    height: 4px;
    border-radius: 2px;
    outline: none;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      height: 20px;
      width: 20px;
      border-radius: 10px;
      background-color: $player-footer-icons-color;
      cursor: pointer;
    }

    &::-moz-range-thumb {
      height: 20px;
      width: 20px;
      border-radius: 10px;
      background-color: $player-footer-icons-color;
      cursor: pointer;
    }

    &::-ms-thumb {
      height: 20px;
      width: 20px;
      border-radius: 10px;
      background-color: $player-footer-icons-color;
      cursor: pointer;
    }
  }

}
</style>
